import request from '../utils/axios'

//获取流程列表
export function GetFlowchartList(params) {
  return request({
    url: '/Flowchart/GetFlowchartListByStaff',
    method: 'post',
    data: params
  })
}

//获取流程节点的类型集合
export function GetTypeDic(type) {
  return request({
    url: `/Flowchart/GetTypeDic?type=${type}`,
    method: 'get'
  })
}

//添加流程表(工作人员)
export function AddFlowchart(params) {
  return request({
    url: `/Flowchart/AddFlowchart`,
    method: 'post',
		data:params
  })
}

//查询流程是否使用中
export function IsUse(id) {
  return request({
    url: `/Flowchart/IsUse?id=${id}`,
    method: 'get'
  })
}

//获取详情(工作人员)
export function GetDetails(id) {
  return request({
    url: `/Flowchart/GetDetails?id=${id}`,
    method: 'get'
  })
}

// 删除流程(工作人员)
export function DeleteFlowchart(id) {
  return request({
    url: `/Flowchart/DeleteFlowchart?id=${id}`,
    method: 'get'
  })
}

// 修改流程(工作人员)
export function UpdateFlowchart(params) {
  return request({
    url: `/Flowchart/UpdateFlowchart`,
    method: 'post',
		data:params
  })
}

// 获取审批流程下拉框(工作人员)
export function GetFlowchartSelectionBox() {
  return request({
    url: `/Flowchart/GetFlowchartSelectionBox`,
    method: 'get'
  })
}

// 获取审批流程下拉框(设计公司/普通用户)
export function GetFlowchartSelectionBox2() {
  return request({
    url: `/Flowchart/GetFlowchartSelectionBox2`,
    method: 'get'
  })
}

// 返回的节点(工作人员)
export function GetBlackFlowchartNode(params) {
  return request({
    url: `/Flowchart/GetBlackFlowchartNode`,
    method: 'post',
		data:params
  })
}

// 获取我的审核流程（普通人员）
export function GetMyFlowcharInfo(id) {
  return request({
    url: `/Flowchart/GetMyFlowcharInfo?id=${id}`,
    method: 'get'
  })
}

// 设计公司获取我的申请流程进度(设计公司)
export function GetFlowcharInfo(params) {
  return request({
    url: `/Flowchart/GetFlowcharInfo`,
    method: 'post',
		data:params
  })
}